import { mapState } from 'vuex'
import {formatTime} from '@/filters/index.js'
import {
  submitNewsComment
} from '@/api'
export default {
  name: 'launcher-article-comment',
  computed: {
    ...mapState(['wechatUser', 'serviceConfig'])
  },
  created() {
    this.getUserInfo()
  },
  mounted() {
    this.getArticleInfo()
    this.getPrevPath()
  },
  filters: {
    formatTime
  },
  data() {
    return {
      defaultAvatar: 'https://wechat-gjqt.jinyi999.cn/mangement-fronted/production/1520490845601_avatar.png',
      userInfo: {},
      articleTitle: '',
      articleId: '',
      content: '',
      myCommentList: [],
      userInput: '',
      prevPath: ''
    }
  },
  methods: {
    getUserInfo() {
      this.userInfo = Object.assign({},this.wechatUser)
      if(this.userInfo.nickname && this.userInfo.nickname.length > 8) this.userInfo.nickname = this.userInfo.nickname.substr(0,8) + '...'
    },
    getArticleInfo() {
      this.articleId = this.$route.params.id
      this.articleTitle = this.$route.params.title
    },
    getPrevPath() {
      this.prevPath = this.$route.params.path
    },
    async submitComment() {
      if(!this.userInput) return this.$message('评论不能为空')
      const curCom = {
        avatarUrl: this.userInfo.headImgUrl,
        nickName: this.userInfo.nickname,
        content: this.userInput,
        time: +new Date()
      }
      try {
        const {code, message} = await this.articleComment(this.userInput)
        // this.$sa.track('comment_article', {
        //   article: this.$route.params.title,
        //   column: this.$route.params.columnName
        // })
        this.$sa.trackSaEn('click_comment_send', {
          type: this.$route.params.type,
          title: this.$route.params.title,
          news_id: this.$route.params.newsId,
          column_name: this.$route.params.columnName
        })
        if (code === 1) {
          this.userInput = ''
          this.$message(message || '提交成功')
          this.myCommentList.unshift(curCom)
        } else {
          this.$message(message || '提交失败')
        }
      } catch(err) {
        console.error(err)
        this.userInput = ''
      }
    },
    async articleComment(inputContent) {
      return await submitNewsComment(inputContent, this.articleId, this.wechatUser.token, this.serviceConfig.appCode, this.$route.params.columnCodes, this.serviceConfig.serverId)
    }
  }
}